import * as React from 'react';
import { createStyles, Text, Group, Title, Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

// Components
import { CompletedIllustration } from '../../../Illustrations/Completed';

// Local Components
import { InterpolatedFormCopy } from '../InterpolatedFormCopy';

const useStyles = createStyles((theme) => {
    return {
        description: {
            whiteSpace: 'pre-line'
        },
        wrapper: {
            display: 'flex',
            alignItems: 'center',
            padding: `calc(${theme.spacing.xl} * 2) calc(${theme.spacing.xl} * 2.5)`,
            // borderRadius: theme.radius.md,
            // backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.white,
            // border: `${rem(1)} solid ${theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[3]}`,

            [theme.fn.smallerThan('sm')]: {
                flexDirection: 'column-reverse',
                padding: theme.spacing.xl
            }
        },

        image: {
            width: '9vw'
        },

        body: {
            // paddingRight: `calc(${theme.spacing.xl} * 4)`,
            flexGrow: 1,

            [theme.fn.smallerThan('sm')]: {
                paddingRight: 0,
                marginTop: theme.spacing.xl
            }
        },

        title: {
            fontFamily: `Greycliff CF, ${theme.fontFamily}`,
            // textAlign: 'center',
            fontWeight: 900,
            // fontSize: 38,

            [theme.fn.smallerThan('sm')]: {
                // fontSize: 32
            }
        },

        controls: {
            display: 'flex',
            marginTop: '2.5rem'
        },

        inputWrapper: {
            width: '100%',
            flex: '1'
        },

        input: {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            borderRight: 0
        },

        control: {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
        }
    };
});

interface EndingSlideProps {
    content?: string | React.ReactNode;
    data: Record<string, any>;
    onActionCb?: () => void;
    trigger?: string;
}

export const EndingSlide: React.FC<EndingSlideProps> = ({ content, data, onActionCb, trigger, ...props }) => {
    const { classes, cx } = useStyles();
    const { t } = useTranslation();

    return (
        <div className={classes.wrapper}>
            {/* <div className={classes.image}>
                <CompletedIllustration />
            </div> */}
            <div className={classes.body}>
                <Title className={classes.title} order={2} mb="lg">
                    {t('endingSlide.youreAllSet', { ns: 'components' })}
                </Title>
                <Text fz="sm" c="dimmed" className={classes.description}>
                    {typeof content === 'string' ? <InterpolatedFormCopy copy={content} {...{ data }} /> : content}
                </Text>

                <Group className={classes.controls} position="right">
                    {trigger === 'onboarding' ? (
                        <>
                            <Button onClick={() => onActionCb?.()}>{t('ok', { ns: 'common' })}</Button>
                        </>
                    ) : (
                        <>
                            <NavLink to={'/client/surveys'}>
                                <Button onClick={() => onActionCb?.()}>
                                    {t('endingSlide.actions.returnToSurveys', { ns: 'components' })}
                                </Button>
                            </NavLink>
                            <Button onClick={() => onActionCb?.()} variant="default">
                                {t('signOut', { ns: 'common' })}
                            </Button>
                        </>
                    )}
                </Group>
            </div>
        </div>
    );
};
